module.exports = __webpack_public_path__ + "7784a613cc5a6fcd043a14998aa7435b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/status.png
// module id = 625
// module chunks = 0